import { IPayloadResetPassword } from "../interfaces/payloads/auth/reset-password.interface";

enum UserAuthStatic {
  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description login method normal
   */
  LoggedUser = "/v2/users/login",
  /**
   * @member {string}
   * @method get
   * @version 2.0
   * @description get current user
   */
  getCurrentUser = "/v2/user/",
  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description google social network login
   */
  LoggedUserGoogleRedirect = "/v2/users/login/google",

  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description request to reset password
   */
  forgotPasswordUser = "/v2/users/forgot-pasword",
  /**
   * @member {string}
   * @method post
   * @version 1.0
   * @description Logout user
   */
  logoutUser = "/v2/users/logout"
}

const UserAuthDynamic = {
  /**
   * @member {string}
   * @method post
   * @version 2.0
   * @description google social network login
   */
  LoggedUserGoogleCallback: (search: string) =>
    `/v2/users/login/google/callback${search}`,

  /**
   * @member {string}
   * @method post
   * @version 1.0
   * @description send new password
   */
  resetPasswordUser: (values: IPayloadResetPassword) =>
    `/v2/users/reset-password/${values.userId}?expires=${values.expires}&signature=${values.signature}`
};

export const LoginEndpoints = {
  ...UserAuthDynamic,
  ...UserAuthStatic
};

export type LoginEndpoints = typeof LoginEndpoints;
